"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBadge = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./IconBadge.css");
var IconBadge = function (_a) {
    var icon = _a.icon, text = _a.text, onClick = _a.onClick, className = _a.className, children = _a.children, inline = _a.inline;
    var inlined = inline ? 'inlined' : 'boxed';
    var childrenInt = react_1.default.useMemo(function () { return (react_1.default.createElement(react_1.default.Fragment, null,
        children && icon ? (react_1.default.createElement("span", { className: "dui-icon-badge__custom-icon" }, children)) : icon ? (react_1.default.createElement("span", { className: (0, classnames_1.default)(icon && 'dui-icon-badge__icon', icon) })) : null,
        text ? react_1.default.createElement("span", { className: "text" }, text) : null)); }, [children, icon, text]);
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)('dui-icon-badge', className, onClick && 'clickable', inlined), onClick: onClick }, childrenInt));
};
exports.IconBadge = IconBadge;
